export enum CustomOptionsEnum {
  All = 0,
  EquipmentFeatureGroupName = 1,
  EquipmentFeatureFeatureName = 2,
  JobType = 3,
  ShippingMethod = 4,
}
